<template>

    <div class="row">
        <div class="col-sm-6">
            <registered
                :url="route('api.v1.hr.users.vacationhours.registered', {id:getHrUser.uuid}, false)"
            ></registered>
        </div>
        <div class="col-sm-6">
            <planned
                :url="route('api.v1.hr.users.vacationhours.planned', {id:getHrUser.uuid}, false)"
            ></planned>
        </div>
    </div>

</template>

<script>

import { mapGetters } from "vuex";
import Planned from "../../../components/HR/VacationHours/Planned";
import Registered from "../../../components/HR/VacationHours/Registered";

export default {

    components: {
        Planned,
        Registered,
    },

    computed: {
        ...mapGetters([
            'getHrUser',
        ]),
    },

    metaInfo: {
        title:'Vakantieuren'
    },

    name:'HrUsersVacationHours',

}

</script>
